import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import Step5 from './Step5';
import CampaignSettings from './CampaignSettings';
import { StepsFormWrap } from './CreateCompaign.styles';

const Step4 = ({ setData, data, NextStep, goBack, type, step, setStep, totalStep = 7, setCompanyDetailsModal }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('offer');

  const handleSubmit = e => {
    setData(prev => ({ ...prev, step4: { ...e } }));
    // setShowCampaignSettings(true);
    setActiveTab('tone'); // 👈 switch tab
  };

  const handleFetchDetails = async () => {
    const website = form.getFieldValue('company_website');
    if (!website) return Toast({ type: 'error', message: 'Please enter a company website' });

    try {
      setLoading(true);
      const res = await campaignService.getCompanyDetails(website);
      if (res?.data?.success) {
        form.setFieldsValue({
          company_details: res?.data?.company_detail,
        });
        Toast({ type: 'success', message: 'Company details fetched successfully' });
      } else {
        Toast({ type: 'error', message: res?.data?.company_detail });
      }
    } catch (err) {
      Toast({ type: 'error', message: 'Failed to fetch details.' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.step4) {
      form.setFieldsValue({
        user_company: data?.step4?.user_company,
        company_website: data?.step4?.company_website,
        company_details: data?.step4?.company_details,
        offer: data?.step4?.offer,
      });
    }
  }, [data?.step4]);

  return (
    <StepsFormWrap>
      {activeTab === 'signature' ? (
        <Step5
          setData={setData}
          data={data}
          setStep={setStep}
          NextStep={NextStep}
          loading={loading}
          step={step}
          setActiveTab={setActiveTab}
        />
      ) : (
        <>
          <div className="tab-btns">
            <span className={`btn ${activeTab === 'offer' ? 'active' : ''}`}>Offer</span>
            <span className={`btn ${activeTab === 'tone' ? 'active' : ''}`}>Tone</span>
          </div>

          {/* Step 4 Form */}
          {activeTab === 'offer' ? (
            <Form className="form-area" form={form} onSubmit={handleSubmit}>
              <div className="content-wrap">
                <div className="head">
                  <span className="heading">Offer Details</span>
                  <p>Add the offer details that will be used in your cold email campaigns.</p>
                </div>

                <Form.Item
                  inputSm
                  colorBg
                  label="Company Name"
                  name="user_company"
                  placeholder="Enter company name"
                  rules={[{ required: true, message: 'Company name is Required' }]}>
                  <Field />
                </Form.Item>

                <Form.Item
                  inputSm
                  colorBg
                  label="Company Website"
                  name="company_website"
                  placeholder="Enter company website"
                  suffix={
                    <Button
                      disabled={loading}
                      loader={loading}
                      type="button"
                      onClick={handleFetchDetails}
                      className="fetch-details-btn">
                      Fetch Details
                    </Button>
                  }
                  rules={[{ required: true, message: 'Company website is required' }]}>
                  <Field />
                </Form.Item>

                <Form.Item
                  colorBg
                  label="Company Details"
                  name="company_details"
                  type="textarea"
                  placeholder="Enter Company Details"
                  rules={[{ required: true, message: 'Company Details are required' }]}>
                  <Field />
                </Form.Item>

                <Form.Item
                  colorBg
                  label="Your Offer"
                  name="offer"
                  placeholder="Add your offer here"
                  type="textarea"
                  rules={[{ required: true, message: 'Offer is required' }]}>
                  <Field />
                </Form.Item>
              </div>

              <div className="btn-holder">
                {/* <Button newStyle variant="outline" width="155px">
                  Need Help?
                </Button>
                <div className="btn-wrap">
                </div> */}
                <Button
                  newStyle
                  rounded
                  variant="outline"
                  width="155px"
                  type="button"
                  onClick={() => setCompanyDetailsModal(false)}>
                  Cancel
                </Button>
                <Button newStyle rounded variant="darkBlue" width="155px" type="submit">
                  Next
                </Button>
              </div>
            </Form>
          ) : (
            <CampaignSettings
              setData={setData}
              NextStep={NextStep}
              data={data}
              step={step}
              // setShowCampaignSettings={setShowCampaignSettings}
              setActiveTab={setActiveTab}
            />
          )}
        </>
      )}

      {/* Step 5 (after Campaign Settings) */}
      {/* {showStep5 && <Step5 />} */}
    </StepsFormWrap>
  );
};

export default Step4;
